/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./FilePreview.css'); }
var Icon_1 = require("./Icon");
var Spinner_1 = require("./Spinner");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-filePreview");
var FilePreview = /** @class */ (function (_super) {
    tslib_1.__extends(FilePreview, _super);
    function FilePreview(props) {
        var _this = _super.call(this, props) || this;
        _this.img = null;
        _this.cache = {};
        _this.state = {
            loading: props.loading === undefined ? !!props.src : props.loading
        };
        return _this;
    }
    FilePreview.prototype.componentWillUnmount = function () {
        this.clear();
    };
    FilePreview.prototype.componentDidMount = function () {
        if (this.props.src) {
            this.load(this.props.src);
        }
    };
    FilePreview.prototype.componentWillReceiveProps = function (_a) {
        var src = _a.src;
        if (src !== this.props.src) {
            this.clear();
            this.load(src);
        }
    };
    FilePreview.prototype.clear = function () {
        this.img = null;
    };
    FilePreview.prototype.load = function (src) {
        var _this = this;
        if (!src) {
            return;
        }
        if (this.cache[src]) {
            this.setState({
                loading: false
            });
            return;
        }
        this.setState({
            loading: true
        });
        this.img = new Image();
        this.img.onload = function () {
            _this.setState({
                loading: false
            });
            _this.cache[src] = true;
        };
        this.img.src = src;
    };
    FilePreview.prototype.render = function () {
        var _a = this.props, className = _a.className, onClick = _a.onClick, _b = _a.href, href = _b === void 0 ? "#" : _b, title = _a.title, iconType = _a.iconType, onIconClick = _a.onIconClick, src = _a.src, label = _a.label, target = _a.target, rel = _a.rel, _c = _a.ratio, ratio = _c === void 0 ? 224 / 152 : _c;
        var loading = this.props.loading === undefined
            ? this.state.loading
            : this.props.loading;
        return (React.createElement("div", { className: classnames(moduleClassName(), className), style: { paddingTop: ratio * 100 + "%" } },
            loading ? (React.createElement(Spinner_1.Spinner, null)) : (React.createElement("a", { href: href, title: title, onClick: onClick, target: target, rel: rel, className: moduleClassName("image") },
                React.createElement("img", { src: src, alt: label }))),
            !loading && (label || iconType) && (React.createElement("div", { className: moduleClassName("label") },
                React.createElement("div", { className: moduleClassName("labelText") }, label),
                !!iconType && (React.createElement("button", { type: "button", className: moduleClassName("action"), onClick: onIconClick },
                    React.createElement(Icon_1.Icon, { type: iconType, className: moduleClassName("icon") })))))));
    };
    FilePreview.propTypes = {
        onClick: PropTypes.func,
        href: PropTypes.string,
        title: PropTypes.string,
        className: PropTypes.string,
        iconType: PropTypes.oneOf(Icon_1.IconTypesArray),
        onIconClick: PropTypes.func,
        src: PropTypes.string,
        label: PropTypes.string,
        target: PropTypes.string,
        loading: PropTypes.bool,
        rel: PropTypes.string,
        ratio: PropTypes.number
    };
    FilePreview.defaultProps = {
        ratio: 224 / 152,
        href: "#"
    };
    return FilePreview;
}(React.Component));
exports.FilePreview = FilePreview;
exports.FilePreviewButton = function FilePreviewButton(_a) {
    var onClick = _a.onClick, label = _a.label, iconType = _a.iconType, _b = _a.ratio, ratio = _b === void 0 ? 224 / 152 : _b, className = _a.className, children = _a.children;
    return (React.createElement("button", { type: "button", onClick: onClick, className: classnames(moduleClassName("button"), className), style: { paddingTop: ratio * 100 + "%" } },
        React.createElement("div", { className: moduleClassName("buttonContent") },
            React.createElement(Icon_1.Icon, { type: iconType }),
            React.createElement("br", null),
            label,
            children)));
};
exports.FilePreviewButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    iconType: PropTypes.oneOf(Icon_1.IconTypesArray).isRequired,
    label: PropTypes.string,
    ratio: PropTypes.number
};
exports.FilePreviewButton.defaultProps = {
    ratio: 224 / 152
};